export default __webpack_public_path__ + "static/media/next.7568cec3.svg";